import { object } from '@calendly/form/validation'

import {
  getEditFormValidationSchema,
  getMoreOptionsValidationSchema
} from 'features/event_type_editor'

import { getNotificationSettingsValidationSchema } from './notification_settings'

export const getFullValidationSchema = ({ eventType }) => object({})
  .concat(getEditFormValidationSchema({
    eventType,
    paymentsUpfrontVariant: null,
    requireLocationKind: true,
    useCrudValidationMessages: true,
  }))
  .concat(getMoreOptionsValidationSchema(eventType, {
    showPaymentsUpfront: false,
    useCrudValidationMessages: true
  }))
  .concat(getNotificationSettingsValidationSchema())
